import { Link } from "react-router-dom";
import { GitCompare, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { compareStore, useCompare } from "@/lib/compare-store";

const CompareBar = () => {
  const list = useCompare();
  if (list.length === 0) return null;

  return (
    <div className="fixed bottom-4 left-1/2 z-40 -translate-x-1/2 animate-fade-in">
      <div className="flex items-center gap-3 rounded-full border border-border bg-card/95 px-4 py-2.5 shadow-lg backdrop-blur-md">
        <GitCompare className="h-4 w-4 text-primary" />
        <div className="flex items-center gap-1.5">
          {list.map((slug) => (
            <span
              key={slug}
              className="inline-flex items-center gap-1 rounded-full bg-secondary px-2.5 py-1 text-xs font-medium text-secondary-foreground"
            >
              {slug}
              <button
                onClick={() => compareStore.remove(slug)}
                className="hover:text-foreground"
                aria-label={`Remove ${slug}`}
              >
                <X className="h-3 w-3" />
              </button>
            </span>
          ))}
        </div>
        <Button asChild size="sm" disabled={list.length < 2} className="rounded-full">
          <Link to={`/compare?d=${list.join(",")}`}>
            Compare ({list.length})
          </Link>
        </Button>
        <button
          onClick={() => compareStore.clear()}
          className="text-xs text-muted-foreground hover:text-foreground"
        >
          Clear
        </button>
      </div>
    </div>
  );
};

export default CompareBar;
